import * as tslib_1 from "tslib";
import { BehaviorSubject, forkJoin, of, Subject, } from 'rxjs';
import { switchMap, takeUntil, tap, } from 'rxjs/operators';
import { FormComponent } from './ui-form.component';
/**
 * Page Component route dependent `entities/:id`
 * used for creating, editing an entity
 */
var UpsertPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UpsertPageComponent, _super);
    function UpsertPageComponent(_route, _router, _appState) {
        var _this = _super.call(this) || this;
        _this._route = _route;
        _this._router = _router;
        _this._appState = _appState;
        _this.initialContextLoading$ = new BehaviorSubject(true);
        _this.loading$ = new BehaviorSubject(true);
        _this._initialContext$ = [of(null)];
        _this._ignoreDirtyStatus = false;
        _this._destroyed$ = new Subject();
        _this._id = NaN;
        _this._isEditMode = false;
        _this._forceNavigateBaseUrl = function () {
            // mark as pristine to prevent trigger of unsaved changes guard
            _this.form.markAsPristine();
            _this._router.navigate([_this._baseUrl]);
        };
        _this._getFieldConfigFn = function (formData) {
            return function (key, ignoreNullValues, validators) {
                var _a;
                if (ignoreNullValues === void 0) { ignoreNullValues = false; }
                // if <T> contains key 'id', it will be skipped as to not pollute the FormControl.
                if (key === 'id') {
                    return {};
                }
                var useFormData = !!formData &&
                    (!ignoreNullValues ||
                        formData[key] != null);
                var value = useFormData ?
                    _this._getFieldValue(key, formData) :
                    _this.defaults[key];
                return _a = {},
                    _a[key] = [
                        value,
                        validators || _this.validators[key],
                    ],
                    _a;
            };
        };
        _this._getFieldValue = function (key, formData) {
            return _this._hasDisabled(key) ?
                {
                    value: formData[key],
                    disabled: _this.defaults[key].disabled,
                } :
                formData[key];
        };
        _this.id = Number(_this._route.snapshot.params['id']);
        _appState.user.folder.change$
            .pipe(takeUntil(_this._destroyed$))
            .subscribe(function () { return _this._ignoreDirtyStatus = true; });
        return _this;
    }
    Object.defineProperty(UpsertPageComponent.prototype, "isEditMode", {
        /**
         * Dependendent on route param `id`. E.g.: `entities/:id`
         * Used to decide how form initialization in `ngOnInit` is treated
         */
        get: function () {
            return this._isEditMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpsertPageComponent.prototype, "hasUnsavedChanges", {
        get: function () {
            return this._ignoreDirtyStatus ?
                false :
                !!this.form &&
                    (this.loading$.value ||
                        this.form.dirty);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpsertPageComponent.prototype, "isSubmitDisabled", {
        get: function () {
            return this._isSubmitDisabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpsertPageComponent.prototype, "id", {
        /**
         * id property is extracted from route params
         * and dictates if in Create / Edit mode.
         */
        get: function () { return this._id; },
        set: function (id) {
            this._id = id;
            this._isEditMode = !isNaN(id);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpsertPageComponent.prototype, "_baseUrl", {
        get: function () {
            var baseRoute = this._router.url
                .split('/')
                .filter(Boolean)[0];
            return baseRoute ? "/" + baseRoute : '/';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpsertPageComponent.prototype, "_isSubmitDisabled", {
        get: function () {
            return this.loading$.value ||
                !this.form ||
                !this.form.dirty ||
                !this.form.valid;
        },
        enumerable: true,
        configurable: true
    });
    UpsertPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        forkJoin(this._initialContext$)
            .pipe(switchMap(function () {
            return !_this.isEditMode ?
                of(undefined) :
                _this._getInstance();
        }), tap(function (_) { return _this.initialContextLoading$.next(false); }), takeUntil(this._destroyed$)).subscribe(function (formData) {
            var configFn = _this._getFieldConfigFn(formData);
            _this._initForm(_this._getControlsConfig(configFn), configFn, formData);
        }, function () { return _this.isEditMode && _this._router.navigate([_this._baseUrl]); });
    };
    UpsertPageComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    UpsertPageComponent.prototype._getControlsConfig = function (configFn) {
        return Object.keys(this.fields)
            .reduce(function (controlConfig, key) { return (tslib_1.__assign({}, controlConfig, configFn(key))); }, {});
    };
    UpsertPageComponent.prototype._hasDisabled = function (key) {
        return this.defaults[key] &&
            this.defaults[key].disabled !== undefined;
    };
    return UpsertPageComponent;
}(FormComponent));
export { UpsertPageComponent };
